import {Component, Vue} from "vue-property-decorator";

@Component
export default class SaldoMixin extends Vue {
    private euroFormatter = new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    public formatSaldo(item: any): string {
        const saldo = item?.balance?.saldo;
        return this.formatNumber(saldo);
    }

    public formatSaldoBalance(value: any): string {
        return this.formatNumber(value);
    }

    private formatNumber(value: any): string {
        if (typeof value !== "number") {
            value = parseFloat(value);
        }
        if (isNaN(value)) {
            return "0,00 €";
        }
        return this.euroFormatter.format(value);

        // if(false){ // in case Reis Asks
        //   // Format using Intl
        //   let formatted = this.euroFormatter.format(value);
        //
        //   // Normalize non-breaking space
        //   formatted = formatted.replace(/\u00A0/g, " ");
        //
        //   // Remove trailing ",00"
        //   if (formatted.endsWith(",00 €")) {
        //     console.log('yes '+formatted)
        //     formatted = formatted.replace(",00 €", " €");
        //   }
        //
        //   // Remove trailing zero after comma, e.g. ",60 €" → ",6 €"
        //   formatted = formatted.replace(/,(\d)0 €$/, ",$1 €");
        //
        //   return formatted
        // }
    }
}
